import React from "react";

function Color_Gradient() {
  return (
    <div>
      <h1>Color_Gradient Component</h1>
      <p>This is the Color Gradient tutorial page content.</p>
    </div>
  );
}

export default Color_Gradient;
